module.exports = __webpack_public_path__ + "img/PaymentKH.eac42419.png";